import {constants} from '../../constants';
import {TrackVisitHealthCenterInterface} from '../interfaces';

import {TrackingUtilsService} from './tracking-utils.service';
import {AnalyticsService} from '../../modules/core/services/analytics.services';
import {retrieveAnalyticsServiceValuesCase} from './retrieve-analytics-service-values.case';

export const trackVisitHealthCenterPayloadCase = (
  analyticsService: AnalyticsService,
  trackingUtilsService: TrackingUtilsService,
  guestData?: any,
): TrackVisitHealthCenterInterface | undefined => {
  if (!guestData) return undefined;
  const {analyticsData, language} = retrieveAnalyticsServiceValuesCase(analyticsService, trackingUtilsService);

  return {
    interaction: constants.INTERACTIONS.HEALTH_CENTER_CLICK,
    pageName: constants.PAGE_NAME_FOR_TRACKING.READY_TO_BOARD,
    brand: trackingUtilsService.getBrandCode(),
    country: analyticsData?.country,
    language: language ?  language.toLowerCase() : 'en',
    siteSection: analyticsData?.channel,
    consumerId: analyticsData?.paxid,
    loyaltyNum: trackingUtilsService.getLoyaltyNum(guestData.loggedInPaxId),
    passengerId: guestData.loggedInPaxId ?? constants.DEFAULT_GUEST_ID_FOR_TRACKING.ID,
    vdsId: trackingUtilsService.getVdsId(),
    bookingId: guestData.bookingId,
    platform: trackingUtilsService.getPlatform(),
    loginStatus : constants.LOGIN_STATUS.LOGGED_IN
  };
}
